import { ACTION } from "./constants";
import request from "../../../../utils/request";
import { requestConfig } from "../../../../config/apiResource";
import { showMainLoader, hideMainLoader } from "../../../actions";
import { formDataGenerator } from "../../../../utils/common";

export function investorFormList(formData) {
  let formDataValue;
  if (!__CLIENT__) {
    let data = {
      search: "",
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
  }
  return (dispatch) => {
    return request(requestConfig.investorFormList(formDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.INVESTOR_FORM_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with insight video data: " + error);
      });
  };
}
export function noticesAgendaList(formData) {
  let formDataValue;
  if (!__CLIENT__) {
    let data = {
      search: "",
      year: "",
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
  }
  return (dispatch) => {
    return request(requestConfig.noticesAgendaList(formDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.NOTICES_AGENDA_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with insight video data: " + error);
      });
  };
}
export function additionalInfo(formData) {
  let formDataValue;
  if (!__CLIENT__) {
    let data = {
      search: "",
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
  }
  return (dispatch) => {
    return request(requestConfig.additionalInfo(formDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.ADD_INFO_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with insight video data: " + error);
      });
  };
}
export function fundLiteratureDocument(serverData, formData) {
  let formDataValue;
  if (serverData.url) {
    let urlArray = serverData.url.split("/"),
      typeData = urlArray[urlArray.length - 1];

    let data = {
      type: typeData,
      limit: 10,
      offset: 0,
      categories: "",
      fund_type: "",
      horizon: "",
      risk_profile: "",
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
  }

  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.fundLiteratureDocument(formDataValue))
      .then((json) => {
        dispatch(hideMainLoader());
        json &&
          dispatch({ type: ACTION.FUND_LITERATURE_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with insight video data: " + error);
      });
  };
}
export function clearfundLiteratureDocument() {
  return {
    type: ACTION.CLEAR_FUND_LITERATURE_LIST,
  };
}
export function investorLandingPage() {
  return (dispatch) => {
    return request(requestConfig.investorLandingPage())
      .then((json) => {
        json &&
          dispatch({ type: ACTION.INVESTOR_LANDING_PAGE, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with ivestor service data: " + error);
      });
  };
}
export function getInvestorFaq(serverData, formData, type) {
  let formDataValue, typeDataValue;
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    typeDataValue = urlArray[urlArray.length - 1];
    let data = {
      search: "",
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
    typeDataValue = type;
  }
  return (dispatch) => {
    return request(requestConfig.getInvestorFaq(formDataValue, typeDataValue))
      .then((json) => {
        json &&
          dispatch({ type: ACTION.INVESTOR_GENERAL_FAQ, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with ivestor service data: " + error);
      });
  };
}

export function getInvestorMarket(serverData,formData, type) {

  let formDataValue, typeDataValue;
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    typeDataValue = urlArray[urlArray.length - 1];
    if(typeDataValue == 'documents'){
      typeDataValue = 'data';
    }
    let data = {
      search: "",
      year:""
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
    typeDataValue = type;
  }

  return (dispatch) => {
    return request(requestConfig.getInvestorMarket(formDataValue, typeDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.INVESTOR_MARKET, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with ivestor service data: " + error);
      });
  };
}

export function getMarketVideoDetail(serverData,typeData) {
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    typeData = urlArray[urlArray.length - 1];
  }
  return (dispatch) => {
    return request(requestConfig.getMarketVideoDetail(typeData))
      .then((json) => {
        json &&
          dispatch({
            type: ACTION.GET_MARKET_VIDEO_DETAILS,
            data: json.data,
          });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
}

export function getFundLitrature(serverData, formData) {
  let formDataValue;
  if (serverData.url) {
    let urlArray = serverData.url.split("/"),
      typeData = urlArray[urlArray.length - 1];

    let data = {
      search: "",
      tab: typeData == "presentation" ? "product presentation" : "leaflets",
      limit: 8,
      offset: 0,
      categories: "",
      fund_type: "",
      horizon: "",
      risk_profile: "",
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
  }

  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.getFundLitrature(formDataValue))
      .then((json) => {
        dispatch(hideMainLoader());
        json &&
          dispatch({ type: ACTION.FUND_LITERATURE_DATA, data: json.data });
        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with fund litrature data: " + error);
      });
  };
}
export function getFactsheet(formData) {
  let formDataValue;
  if (!__CLIENT__) {
    let data = {
      year: 0,
      month: 0,
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
  }
  return (dispatch) => {
    return request(requestConfig.getFactsheet(formDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.FACTSHEET, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with factsheet data: " + error);
      });
  };
}

export function getFactsheetMonth(formData) {
  return (dispatch) => {
    return request(requestConfig.getFactsheetMonth(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.FACTSHEET_MONTH, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with factsheet month data: " + error);
      });
  };
}

export function getadditionalFundInfo(formData) {
  let formDataValue;
  if (!__CLIENT__) {
    let data = {
      search: "",
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
  }
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.getadditionalFundInfo(formDataValue))
      .then((json) => {
        dispatch(hideMainLoader());
        json &&
          dispatch({ type: ACTION.ADDITIONAL_FUND_INFO, data: json.data });
        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with additional fund info month data: " + error);
      });
  };
}
export function fundDocumentFilters() {
  return (dispatch) => {
    return request(requestConfig.fundDocumentFilters())
      .then((json) => {
        json &&
          dispatch({ type: ACTION.FUND_DOCUMENT_FILTER_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with ivestor service data: " + error);
      });
  };
}

export function ouronlineservices(serverData, typeData) {
  let formDataValue;
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    formDataValue = urlArray[urlArray.length - 1];
  } else {
    formDataValue = typeData;
  }

  return (dispatch) => {
    return request(requestConfig.ouronlineservices(formDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.OUR_ONLINE_SERVICES, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with ivestor service data: " + error);
      });
  };
}
export function getAgendaMonth(formData) {
  return (dispatch) => {
    return request(requestConfig.getAgendaMonth(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.AGENDA_MONTH, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with factsheet month data: " + error);
      });
  };
}

export function getSchemeAccountFiltersnew() {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.getSchemeAccountFiltersnew())
      .then((json) => {
        dispatch(hideMainLoader());
        json &&
          dispatch({ type: ACTION.GET_SCHEME_ACCOUNT_FILTER, data: json.data });
        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with scheme account filter data: " + error);
      });
  };
}
export function getSchemeAccountContentnew(formData) {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.getSchemeAccountContentnew(formData))
      .then((json) => {
        dispatch(hideMainLoader());
        json &&
          dispatch({
            type: ACTION.GET_SCHEME_ACCOUNT_CONTENT,
            data: json.data,
          });
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with scheme account content: " + error);
      });
  };
}
export function getWeeklyPortfolioDetails() {
  return dispatch => {
      return request(requestConfig.getWeeklyPortfolioDetails())
          .then((json) => {
              json && dispatch({ type: ACTION.GET_PORTFOLIO_DATA , data: json.data });
              return json;
          }).catch((error) => {
              console.log("Got Error with weekly portfolio details: " + error)
          });
  }
}
